module.exports = __webpack_public_path__ + "img/skm-my.0ff46d98.png";